import CreateAccountToast from 'components/CreateAccountToast';
import ExploreCourtsComponent from 'components/Explore/Courts/ExploreCourts';
import GeoLocationInitializer from 'components/utilities/GeoLocationInitializer';
import Head from 'components/utilities/Head';
import PopppinsFont from 'components/utilities/PoppinsFont';

const title = 'Pickleball Courts';
const description =
  'Find indoor and outdoor pickleball courts, places to play, and local venues near you.';

export default function ExploreCourts() {
  return (
    <GeoLocationInitializer>
      <Head canonicalType="currentUrlStripQuery" title={title} description={description} />
      <PopppinsFont />
      <div className="fixed -left-40 -top-40 -z-100">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <ExploreCourtsComponent />
      <CreateAccountToast />
    </GeoLocationInitializer>
  );
}
